import { render, staticRenderFns } from "./PlgSettings.vue?vue&type=template&id=81ee8168&"
import script from "./PlgSettings.vue?vue&type=script&lang=js&"
export * from "./PlgSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports